import {Inject, Injectable} from '@angular/core';
import {Storage} from '@ionic/storage';
import {from, Observable} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import { FrontStorageService } from '../../storage/storage.service';
import { HOST_THIRD_PARTY_ID } from '../../../tokens/thirdParty.token';
import {IziviaPlatformService} from '../iziviaPlatform.service';

@Injectable({
    providedIn: 'root'
})
export class IziviaStorageService extends FrontStorageService {
    constructor(private readonly storage: Storage,
        private readonly platformService: IziviaPlatformService,
        @Inject(HOST_THIRD_PARTY_ID) private readonly hostThirdPartyId: string) {
        super(hostThirdPartyId);
    }

    public set<T>(key: string, value: T): Observable<T> {
        return this.platformService.ready()
            .pipe(
                switchMap(() => from(this.storage.ready())),
                switchMap(() => this.storage.set(this.prepareKey(key), value))
            );
    }

    public remove(key: string): Observable<void> {
        return this.platformService.ready()
            .pipe(
                switchMap(() => from(this.storage.ready())),
                switchMap(() => this.storage.remove(this.prepareKey((key))))
            );
    }

    public get<T>(key: string): Observable<T | undefined> {
        return this.platformService.ready()
            .pipe(
                switchMap(() => from(this.storage.ready())),
                switchMap(() => this.storage.get(this.prepareKey(key))),
                map(value => value != null ? <T>value : undefined)
            );
    }
}
